import React, { useContext } from 'react'
import styled from 'styled-components'
import AppContext from '../context/appContext'

import ArrowIcon from '../assets/REDESIGN_Assets/LoginScreen/arrow_icon.webp'
import GreenBackArrow from '../assets/REDESIGN_Assets/NavigationBar/green-back-arrow.svg'
import BackButtonIconDark from '../assets/REDESIGN_Assets/theme/back-button-icon-dark.svg'

const GenericBackButtonBox = styled.div`
  width: ${(props) => (props.style.width ? props.style.width : '2.4vw')};
  height: ${(props) => (props.style.height ? props.style.height : '2.4vw')};
  position: ${(props) =>
    props.style.position ? props.style.position : 'relative'};
  display: flex;
  justify-content: ${(props) =>
    props.style.justify ? props.style.justify : 'center'};
  align-items: ${(props) => (props.style.align ? props.style.align : 'center')};
  top: ${(props) => (props.style.top ? props.style.top : 'unset')};
  left: ${(props) => (props.style.left ? props.style.left : 'unset')};
  right: ${(props) => (props.style.right ? props.style.right : 'unset')};
  bottom: ${(props) => (props.style.bottom ? props.style.bottom : 'unset')};
  background-image: linear-gradient(to right, #728ffb, #e896b1 98%);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);

  @media only screen and (max-width: 600px) {
    width: 8vw;
    height: 8vw;
    left: 6vw !important;
    background-image: none;
  }

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 1.5px 1.9px -12px rgba(0, 0, 0, 0.022),
      0 3.7px 4.5px -12px rgba(0, 0, 0, 0.032),
      0 7px 8.5px -12px rgba(0, 0, 0, 0.04),
      0 12.5px 15.2px -12px rgba(0, 0, 0, 0.048),
      0 23.4px 28.4px -12px rgba(0, 0, 0, 0.058),
      0 56px 68px -12px rgba(0, 0, 0, 0.08);
  }
`

const GenericBackButtonIcon = styled.div`
  width: 60%;
  height: 60%;
  background-image: url(${(props) =>
    props.theme && props.theme == 'dark'
      ? GreenBackArrow
      : BackButtonIconDark});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

const GenericBackButton = ({ style, handleClick }) => {
  const defaultStyle = {
    position: 'absolute',
    top: '5%',
    left: '20%',
  }
  const appContext = useContext(AppContext)

  return (
    <GenericBackButtonBox
      style={style == 'default' ? defaultStyle : style}
      onClick={() => handleClick()}
    >
      <GenericBackButtonIcon theme={appContext.appState.theme} />
    </GenericBackButtonBox>
  )
}

export default GenericBackButton
